import type { ModelData } from '@/shared/stores/model-utils'

export const model14InitialModel: ModelData = {
    name: 'Template 14',
    modelId: 'model14',
    templateId: null,
    type: 'DOOR',
    description:
      '14-variant layout with fixed side panels and center double doors',
    width: 2500,
    height: 2200,
    photoId: 0,
    attachments: [],
    parameters: [
      // Main Frame profiles
      {
        positionId: 'top_frame_profile',
        type: 'PROFILE',
        width: 2500,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 0, y: 0, z: 0 },
      },
      {
        positionId: 'left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2200,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 0, y: 0, z: 0 },
      },
      {
        positionId: 'right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2200,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 2440, y: 0, z: 0 },
      },

      // Fixed section vertical frames
      {
        positionId: 'left_vertical_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2141,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 380, y: 60, z: 0 },
      },
      {
        positionId: 'right_vertical_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2141,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 2060, y: 60, z: 0 },
      },

      // Bottom frames
      {
        positionId: 'bottom_left_frame_profile',
        type: 'PROFILE',
        width: 440,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 0, y: 2141, z: 0 },
      },
      {
        positionId: 'door_1_bottom_frame_profile',
        type: 'PROFILE',
        width: 810,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 440, y: 2141, z: 0 },
      },
      {
        positionId: 'door_2_bottom_frame_profile',
        type: 'PROFILE',
        width: 810,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 1280, y: 2141, z: 0 },
      },
      {
        positionId: 'bottom_right_frame_profile',
        type: 'PROFILE',
        width: 440,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 2060, y: 2141, z: 0 },
      },
      //left door left vertical frame
      {
        positionId: 'door_1_left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 440, y: 320, z: 0 },
        hardware: {
          hinges: [
            {
              positionId: 'door_1_left_top_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: -25, y: 60, z: 10 },
            },
            {
              positionId: 'door_1_left_top_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: -25, y: 310, z: 10 },
            },
            {
              positionId: 'door_1_left_top_hinge_3',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: -25, y: 560, z: 10 },
            },
            {
              positionId: 'door_1_left_bottom_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: -25, y: 1350, z: 10 },
            },
            {
              positionId: 'door_1_left_bottom_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: -25, y: 1550, z: 10 },
            },
          ],
        },
      },
      //right door right vertical frame
      {
        positionId: 'door_2_right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 2000, y: 320, z: 0 },
        hardware: {
          hinges: [
            {
              positionId: 'door_2_right_top_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: 60, y: 60, z: 10 },
            },
            {
              positionId: 'door_2_right_top_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: 60, y: 310, z: 10 },
            },
            {
              positionId: 'door_2_right_top_hinge_3',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: 60, y: 560, z: 10 },
            },
            {
              positionId: 'door_2_right_bottom_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: 60, y: 1350, z: 10 },
            },
            {
              positionId: 'door_2_right_bottom_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: 60, y: 1550, z: 10 },
            },
          ],
        },
      },
      // Center vertical frames (between doors)
      {
        positionId: 'door_1_right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 1160, y: 320, z: 0 },
      },
      {
        positionId: 'middle_vertical_frame_profile_center',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 1220, y: 320, z: 0 },
      },
      {
        positionId: 'door_2_left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 1280, y: 320, z: 0 },
      },

      // Horizontal frames
      {
        positionId: 'middle_horizontal_frame_profile',
        type: 'PROFILE',
        width: 1620,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 440, y: 260, z: 0 },
      },
      {
        positionId: 'door_1_top_frame_profile',
        type: 'PROFILE',
        width: 810,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 440, y: 320, z: 0 },
      },
      {
        positionId: 'door_2_top_frame_profile',
        type: 'PROFILE',
        width: 810,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        materialName: '',
        materialId: 0,
        position: { x: 1280, y: 320, z: 0 },
      },

      // Glass Panels
      {
        positionId: 'left_glass_panel',
        type: 'GLASS',
        width: 320,
        height: 2080,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        materialName: 'clear_glass',
        materialId: 0,
        isDouble: false,
        position: { x: 60, y: 60, z: 0 },
      },
      {
        positionId: 'right_glass_panel',
        type: 'GLASS',
        width: 320,
        height: 2080,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        materialName: 'clear_glass',
        materialId: 0,
        isDouble: false,
        position: { x: 2120, y: 60, z: 0 },
      },
      {
        positionId: 'door_top_glass_panel',
        type: 'GLASS',
        width: 1620,
        height: 200,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        materialName: 'clear_glass',
        materialId: 0,
        isDouble: false,
        position: { x: 440, y: 60, z: 0 },
      },
      {
        positionId: 'door_glass_panel_1',
        type: 'GLASS',
        width: 660,
        height: 1765,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        materialName: 'clear_glass',
        materialId: 0,
        isDouble: false,
        position: { x: 500, y: 380, z: 0 },
        hardware: {
          handles: [],
        },
      },
      {
        positionId: 'door_glass_panel_2',
        type: 'GLASS',
        width: 660,
        height: 1765,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        materialName: 'clear_glass',
        materialId: 0,
        isDouble: false,
        position: { x: 1340, y: 380, z: 0 },
        hardware: {
          handles: [
            {
              positionId: 'door_horizontal_handle_right',
              type: 'HORIZONTAL_HANDLE',
              width: 120,
              height: 200,
              thickness: 10,
              color: '#333333',
              materialName: 'aluminum',
              materialId: 0,
              position: { x: -70, y: 750, z: 10 },
            },
          ],
        },
      },
    ],
    doorConfiguration: {
      type: 'fixed_sides_center_doors',
      totalDoorWidth: 2500,
      individualDoorWidth: [810, 810],
      totalHandles: 1,
      openingDirection: 'both_sides', // <- use backend-approved literal
      hingePosition: 'both_sides',
    },
  }
